'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _createCouponTemplate = require('./createCouponTemplate');

var _createCouponTemplate2 = _interopRequireDefault(_createCouponTemplate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Consts used when transforming charges from simplified to complex and vice versa */
var templates = {
    tax: require('./ChargeV2.template.tax.json'),
    percentDiscount: require('./ChargeV2.template.discount.percent.json'),
    fixedDiscount: require('./ChargeV2.template.discount.fixed.json'),
    fixedOneTimeDiscount: require('./ChargeV2.template.discount.fixed-one-time.json'),
    deletedDiscount: require('./ChargeV2.template.discount.deleted.json'),
    tip: require('./ChargeV2.template.tip.v2.json'),
    tipV1: require('./ChargeV2.template.tip.json'),
    callcenter: require('./ChargeV2.template.discount.callcenter.json'),
    loyalty: require('./ChargeV2.template.discount.loyalty.json')
};

templates = (0, _extends3.default)({
    percentDiscountCoupon: (0, _createCouponTemplate2.default)(templates.percentDiscount),
    fixedDiscountCoupon: (0, _createCouponTemplate2.default)(templates.fixedDiscount),
    fixedOneTimeDiscountCoupon: (0, _createCouponTemplate2.default)(templates.fixedOneTimeDiscount)
}, templates);

exports.default = templates;